// Авторизация внутренней CRM: вход/выход через AJAX (mod_auth, mid=33).
// После входа/выхода — location.reload(): остаёмся на том же URL.
export class Auth {
	constructor() {
		this.userId = null;
		this.init();
	}

	init() {
		// userId приходит из серверного рендера (атрибут <user id> → #auth-user-id)
		const authEl = document.getElementById('auth-user-id');
		if (authEl) {
			this.userId = authEl.value;
		}
	}

	isAuthenticated() {
		return !!this.userId;
	}

	async login(form) {
		const errorBox = form.querySelector('[data-auth-error]');
		const btn = form.querySelector('button[type="submit"]');
		const login = form.login ? form.login.value.trim() : '';
		const password = form.password ? form.password.value : '';

		this._hideError(errorBox);

		if (!login || !password) {
			this._showError(errorBox, 'Enter login and password');
			return;
		}

		if (btn) btn.disabled = true;

		try {
			const res = await window.ajax.post('/ajax.php?mid=33', {
				action: 'login',
				login,
				password
			});

			if (res && res.success) {
				location.reload();
				return;
			}

			this._showError(errorBox, (res && res.error) || 'Sign in failed');
		} catch (e) {
			this._showError(errorBox, 'Network error, please try again');
		}

		if (btn) btn.disabled = false;
	}

	async logout() {
		try {
			await window.ajax.post('/ajax.php?mid=33', { action: 'logout' });
		} catch (e) { /* всё равно перезагружаем */ }
		location.reload();
	}

	_showError(box, msg) {
		if (!box) return;
		box.textContent = msg;
		box.classList.add('is-active');
	}

	_hideError(box) {
		if (!box) return;
		box.textContent = '';
		box.classList.remove('is-active');
	}
}
